/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CreateReviewDto } from '../../models/create-review-dto';
import { ReviewTourLeaderItem } from '../../models/review-tour-leader-item';

export interface TravelControllerCreateReviewTourLeader$Params {
  tour_leader_id: number;
      body: CreateReviewDto
}

export function travelControllerCreateReviewTourLeader(http: HttpClient, rootUrl: string, params: TravelControllerCreateReviewTourLeader$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ReviewTourLeaderItem;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerCreateReviewTourLeader.PATH, 'post');
  if (params) {
    rb.path('tour_leader_id', params.tour_leader_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ReviewTourLeaderItem;
      }>;
    })
  );
}

travelControllerCreateReviewTourLeader.PATH = '/travel/reviews/tour-leader/{tour_leader_id}';
